import React, { useMemo } from 'react';

import styles from '../Styles/publicRoutes/style.module.less';
import { BEAM_CLIENT_LOGOS, BEAM_CONTRACTOR_COUNT, COMPANY_COUNT, FALCON_CLIENT_LOGOS } from '../Constants/Constant';
import { isBeamUser } from '../Utils/usersTypes';

export const ClientLogos = () => {
  const { clientsLogos, clientsTitle, logosContainer, logosDivider } = styles;
  const beamUser = isBeamUser();

  const logos = useMemo(() => (beamUser ? BEAM_CLIENT_LOGOS : FALCON_CLIENT_LOGOS), [beamUser]);

  return (
    <div className={clientsLogos}>
      <div className={logosDivider} />

      <div className={clientsTitle}>
        Join <span>{beamUser ? BEAM_CONTRACTOR_COUNT : COMPANY_COUNT}+</span> productive contractors
      </div>

      <div className={logosContainer}>
        {logos.map((logo, idx) => (
          <img key={idx} src={logo?.imgUrl} alt={logo?.alt} />
        ))}
      </div>
    </div>
  );
};
